export const STORAGE = {
  USER_KEY: "user-data",
  USER_REGI_KEY: "register-data",
  APPOINTMENT_KEY: "patient-appointment",
};
